import { useEffect, useRef, useState } from "react";

const CommentForm = ({
  handleSubmit,
  submitLabel,
  hasCancelButton = false,
  handleCancel,
  initialText = "",
  draftKey = "new",
  onDraftChange,
}) => {
  const [text, setText] = useState(initialText);
  const onDraftChangeRef = useRef(onDraftChange);

  useEffect(() => {
    onDraftChangeRef.current = onDraftChange;
  }, [onDraftChange]);

  useEffect(() => {
    const isDirty =
      String(text || "").trim().length > 0 &&
      String(text || "") !== String(initialText || "");

    if (typeof onDraftChangeRef.current === "function") {
      onDraftChangeRef.current(draftKey, isDirty ? text : "");
    }
  }, [draftKey, initialText, text]);

  useEffect(() => {
    return () => {
      if (typeof onDraftChangeRef.current === "function") {
        onDraftChangeRef.current(draftKey, "");
      }
    };
  }, [draftKey]);

  const onSubmit = (event) => {
    event.preventDefault();
    handleSubmit(text);
    setText("");
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="input-group input-group-sm">
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Please write a comment"
          aria-label="Recipient's username"
          aria-describedby="button-addon2"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <button
          className="btn btn-outline-success"
          type="submit"
          id="button-addon2"
          disabled={!text.length}
        >
          {submitLabel}
        </button>
        {hasCancelButton && (
          <button
            className="btn btn-outline-danger"
            type="button"
            id="button-addon3"
            onClick={handleCancel}
          >
            Cancel
          </button>
        )}
      </div>
    </form>
  );
};

export default CommentForm;
